import { LifeSubTypeLike } from '../../types';

export const Unknown: LifeSubTypeLike = {
	isLifeAddDisabled: () => false,
	getCoverageOptions: () => null,
};
